import fraTable from "../data/fra-table.json";

export interface Fra {
  years: number;
  months: number;
}

/**
 * Look up Full Retirement Age (years + months) for a given birth year.
 * Follows SSA's published table at https://www.ssa.gov/oact/progdata/nra.html.
 * Throws on birth years before the earliest table entry.
 */
export function lookupFra(birthYear: number): Fra {
  for (const row of fraTable.table) {
    const max = row.birth_year_max ?? Number.POSITIVE_INFINITY;
    if (birthYear >= row.birth_year_min && birthYear <= max) {
      return { years: row.fra_years, months: row.fra_months };
    }
  }
  throw new Error(
    `No FRA entry for birth year ${birthYear} — earliest supported year is ${fraTable.table[0].birth_year_min}.`,
  );
}

/** FRA expressed in whole months from birth (e.g., FRA 66y 2mo -> 794). */
export function fraInMonths(birthYear: number): number {
  const fra = lookupFra(birthYear);
  return fra.years * 12 + fra.months;
}

/** Exposes the data-file last_verified date for PDF/meta footers. */
export function getFraTableVerified(): string {
  return fraTable.last_verified;
}
